export class UserConsts {
  public static readonly NameMinLength: number = 1;

  public static readonly NameMaxLength: number = 100;

  public static readonly EmailAddressMaxLength: number = 500;
}
export default UserConsts;
